import ledgerApi from "@/api/ledger";

const getDefaultState = () => ({
  onAttemptsConfig: {
    pagination: {
      page: null,
      limit: null,
      sort: null,
      ordering: null,
    },
    queryParams: {},
    paginationCount: 0,
  },

  onAttempts: [],
  onAttemptsLoading: false,
  onAttemptsError: false,
  onAttemptsErrorResponse: null,

  postOnNewAttemptsLoading: false,
  postOnNewAttemptsError: false,
  postOnNewAttemptsErrorResponse: null,

  downloadOnAttemptsLoading: {},
  downloadOnAttemptsError: false,
  downloadOnAttemptsErrorResponse: null,

  attemptId: null,

  uploadAuddisLoading: false,
  uploadAuddisError: false,
  uploadAuddisErrorResponse: null,
  
  uploadAllEntriesLoading: false, 
  uploadAllEntriesError: false,
  uploadAllEntriesErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  FETCH_ON_ATTEMPTS_BEGIN(state) {
    state.onAttemptsLoading = true;
    state.onAttemptsError = false;
    state.onAttemptsErrorResponse = null;
  },
  FETCH_ON_ATTEMPTS_SUCCESS(state, payload) {
    state.onAttempts = payload.data;
    state.onAttemptsConfig.paginationCount = payload['pagination-count'];
    state.onAttemptsLoading = false;
  },
  FETCH_ON_ATTEMPTS_FAILED(state, error) {
    state.onAttemptsLoading = false;
    state.onAttemptsError = true;
    state.onAttemptsErrorResponse = error;
  },

  POST_ON_NEW_ATTEMPTS_BEGIN(state) {
    state.postOnNewAttemptsLoading = true;
    state.postOnNewAttemptsError = false;
    state.postOnNewAttemptsErrorResponse = null;
  },
  POST_ON_NEW_ATTEMPTS_SUCCESS(state) {
    this._vm.$set(state, 'onReadyAccounts', []);
    state.postOnNewAttemptsLoading = false;
  },
  POST_ON_NEW_ATTEMPTS_FAILED(state, error) {
    state.postOnNewAttemptsLoading = false;
    state.postOnNewAttemptsError = true;
    state.postOnNewAttemptsErrorResponse = error;
  },

  DOWNLOAD_ON_ATTEMPTS_BEGIN(state, id) {
    this._vm.$set(state.downloadOnAttemptsLoading, id, true);
    state.downloadOnAttemptsError = false;
    state.downloadOnAttemptErrorResponse = null;
  },
  DOWNLOAD_ON_ATTEMPTS_SUCCESS(state, id) {
    this._vm.$delete(state.downloadOnAttemptsLoading, id, false);
  },
  DOWNLOAD_ON_ATTEMPTS_FAILED(state, { id, error }) {
    this._vm.$delete(state.downloadOnAttemptsLoading, id, false);
    state.downloadOnAttemptsError = true;
    state.downloadOnAttemptsErrorResponse = error;
  },

  UPDATE_ON_ATTEMPTS_CONFIG_FILTERS(state) {
    state.onAttemptsConfig.pagination.page = 1;
  },

  UPDATE_ON_ATTEMPTS_CONFIG_PAGINATION(state, { pagination, queryParams }) {
    const queryKeyMap = {};

    if(pagination) {
      for(let param in state.onAttemptsConfig.pagination) {
        if(pagination[param]) {
          state.onAttemptsConfig.pagination[param] = pagination[param];
        }
      }
    }

    if(queryParams) {
      for(let param in state.onAttemptsConfig.queryParams) {
        if(queryParams.hasOwnProperty(param)) {
          if(queryKeyMap[param].includes("__in") && typeof queryParams[param] === "string") {
            state.onAttemptsConfig.queryParams[param] = queryParams[param].split(",");
          } else {
            state.onAttemptsConfig.queryParams[param] = queryParams[param];
          }
        }
      }
    }
  },

  SET_ATTEMPT_ID(state, id) {
    state.attemptId = id;
  },
  CLEAR_ATTEMPT_ID(state) {
    state.attemptId = null;
  },

  UPLOAD_AUDDIS_BEGIN(state) {
    state.uploadAuddisLoading = true;
    state.uploadAuddisError = false;
    state.uploadAuddisErrorResponse = null;  
  },
  UPLOAD_AUDDIS_SUCCESS(state) {
    state.uploadAuddisLoading = false;
  },
  UPLOAD_AUDDIS_ERROR(state, error) {
    state.uploadAuddisLoading = false;
    state.uploadAuddisError = true;
    state.uploadAuddisErrorResponse = error;  
  },

  UPLOAD_ALL_ENTRIES_BEGIN(state) {
    state.uploadAllEntriesLoading = true;
    state.uploadAllEntriesError = false;
    state.uploadAllEntriesErrorResponse = null;
  },
  UPLOAD_ALL_ENTRIES_SUCCESS(state) {
    state.uploadAllEntriesLoading = false;
  },
  UPLOAD_ALL_ENTRIES_ERROR(state, error) {
    state.uploadAllEntriesLoading = false;
    state.uploadAllEntriesError = true;
    state.uploadAllEntriesErrorResponse = error;
  },

  RESET_ON_ATTEMPTS_STORE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async fetchOnAttempts({ dispatch, state, commit }) {
    commit('FETCH_ON_ATTEMPTS_BEGIN');
    const url = new URL(window.location);
    const query = {};

    Object.entries({ ...state.onAttemptsConfig.pagination, ...state.onAttemptsConfig.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
        url.searchParams.set(k,v);
      } else {
        url.searchParams.delete(k);
      }
    });

    window.history.pushState(null, '', url.toString());

    try{
      const response = await ledgerApi.fetchOnAttempts(query);
      commit('FETCH_ON_ATTEMPTS_SUCCESS', { ...response.headers, data: response.data });
    } catch(error) {
      commit('FETCH_ON_ATTEMPTS_FAILED', error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },

  async postOnNewAttempts({ dispatch, commit }, payload) {
    commit('POST_ON_NEW_ATTEMPTS_BEGIN');
    try {
      await ledgerApi.postOnNewAttempts(payload);
      commit('POST_ON_NEW_ATTEMPTS_SUCCESS');
    } catch(error) {
      commit('POST_ON_NEW_ATTEMPTS_FAILED', error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },

  async downloadOnAttempts({ dispatch, commit }, { id, fileId, fileType, fileName }) {
    commit('DOWNLOAD_ON_ATTEMPTS_BEGIN', fileId);
    try {
      const response = await ledgerApi.downloadOnAttempts({ id, fileId });
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      const file = fileType === 'Submission Report' ? `0N-Attempt-${id}.csv` : fileName;
      link.setAttribute('download', file);
      document.body.appendChild(link);
      link.click();
      commit('DOWNLOAD_ON_ATTEMPTS_SUCCESS', fileId);
    } catch(error) {
      commit('DOWNLOAD_ON_ATTEMPTS_FAILED', { fileId, error });
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },

  updateOnAttemptsConfigFilters({ commit, dispatch }, payload) {
    commit('UPDATE_ON_ATTEMPTS_CONFIG_FILTERS', payload);
    dispatch('fetchOnAttempts');
  },

  updateOnAttemptsConfigPagination({ commit, dispatch }, payload) {
    commit('UPDATE_ON_ATTEMPTS_CONFIG_PAGINATION', payload);
    dispatch('fetchOnAttempts');
  },

  async uploadAuddis({ commit, dispatch }, payload) {
    commit('UPLOAD_AUDDIS_BEGIN');
    try {
      const response = await ledgerApi.uploadAuddis(payload);
      commit('UPLOAD_AUDDIS_SUCCESS');
      dispatch('alerts/setAlert', { type: 'success', message: response.data.message }, { root: true });
    } catch(error) {
      commit('UPLOAD_AUDDIS_ERROR', error);
      dispatch('alerts/setAlert', { type: 'error', message: error.response.data.message }, { root: true });
    }
  },

  async uploadAllEntries({ commit, dispatch }, payload) { 
    commit('UPLOAD_ALL_ENTRIES_BEGIN');
    try {
      const response = await ledgerApi.uploadAllEntries(payload);
      commit('UPLOAD_ALL_ENTRIES_SUCCESS');
      dispatch('alerts/setAlert', { type: 'success', message: response.data.message }, { root: true });
    } catch(error) {
      commit('UPLOAD_ALL_ENTRIES_ERROR', error);
      dispatch('alerts/setAlert', { type: 'error', message: error.response.data.message }, { root: true });
    }
  }
};

const getters = {
  getOnAttemptsConfig: state => state.onAttemptsConfig,

  getOnAttempts: state => state.onAttempts,
  getOnAttemptsLoading: state => state.onAttemptsLoading,
  getOnAttemptsError: state => state.onAttemptsError,
  getOnAttemptsErrorResponse: state => state.onAttemptsErrorResponse,

  getPostOnNewAttemptsLoading: state => state.postOnNewAttemptsLoading,
  getPostOnNewAttemptsError: state => state.postOnNewAttemptsError,
  getPostOnNewAttemptsErrorResponse: state => state.postOnNewAttemptsErrorResponse,

  getDownloadOnAttemptsLoadingById: state => (id) => state.downloadOnAttemptsLoading[id],
  getDownloadOnAttemptsError: state => state.downloadOnAttemptsError,
  getDownloadOnAttemptsErrorResponse: state => state.downloadOnAttemptsErrorResponse,

  getAttemptId: state => state.attemptId,

  getUploadAuddisLoading: state => state.uploadAuddisLoading,
  getUploadAuddisError: state => state.uploadAuddisError,
  getUploadAuddisErrorResponse: state => state.uploadAuddisErrorResponse,

  getUploadAllEntriesLoading: state => state.uploadAllEntriesLoading,
  getUploadAllEntriesError: state => state.uploadAllEntriesError,
  getUploadAllEntriesErrorResponse: state => state.uploadAllEntriesErrorResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  